import moment from 'moment';
import { Spinner } from '../../../commonComponents/Spinner';
import { useSelector } from 'react-redux';
import { createLoadingSelector } from '../../../../apis/selectors';
import history from '../../../../history';
import { Colors } from '../../../../themes/colors';
import { Table } from '../../../commonComponents/Table/Table';
import { TabViewContainer } from '../../../commonComponents/TabViewContainer';
import { style } from '../../../commonComponents/user-column';
import { Filters } from './components/Filters';
import { useUserPermanentJobList } from './hooks/useUserPermanentJobList';

const loadingSelector = createLoadingSelector(['GET_ALL_METADATA', 'GET_ALL_PROFESSIONS']);

export const UserPermanentJobListV2 = () => {
  const currentUser = useSelector((state) => state.users.currentUser);
  const isInitialLoading = useSelector((state) => loadingSelector(state));

  const { data, isLoading, filters, total, totalPages, handleFilterChanged, handlePageChanged } =
    useUserPermanentJobList(currentUser?.id);

  if (isInitialLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '50px' }}>
        <Spinner />
      </div>
    );
  }

  return (
    <TabViewContainer
      style={{
        display: 'flex',
        justifyContent: 'center',
        width: '80%',
      }}
      title="Permanent Jobs"
      variant="card"
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
        <div style={{ alignSelf: 'flex-end' }}>
          <button
            type="button"
            className="btn btn-info"
            onClick={() => history.push('/permanent-job/post', { office: currentUser })}
          >
            Post Permanent Job
          </button>
        </div>
        <Filters filters={filters} handleFilterChanged={handleFilterChanged} />
        <div style={{ alignSelf: 'flex-end' }}>
          <span
            style={{
              fontSize: 20,
              fontWeight: 'bold',
              color: Colors.neutral_600,
            }}
          >
            Total | {total !== undefined ? Intl.NumberFormat().format(total) : ''}
          </span>
        </div>
      </div>

      <div style={{ borderBottom: `1px solid ${Colors.divider}`, margin: '20px 0' }} />

      <Table
        filter={filters}
        columns={[
          {
            id: 'status',
            selector: ({ status }) => status,
            name: 'Status',
            width: '150px',
            style: { ...style.tableText, textTransform: 'capitalize' },
          },
          {
            id: 'candidateCount',
            selector: ({ candidateCount }) => candidateCount || 0,
            name: 'Candidates',
            width: '120px',
            style: style.tableText,
          },
          {
            id: 'createdAt',
            selector: ({ createdAt }) =>
              createdAt ? moment(createdAt).format('ddd, MMM Do, YYYY') : '-',
            name: 'Created',
            sortable: true,
            style: style.tableText,
          },
          {
            id: 'jobTitle',
            selector: ({ title }) => title,
            name: 'Listing Name',
            style: style.tableText,
          },
          {
            id: 'updatedAt',
            selector: ({ updatedAt }) =>
              updatedAt ? moment(updatedAt).format('ddd, MMM Do, YYYY') : '-',
            name: 'Last Edited',
            sortable: true,
            style: style.tableText,
          },
          {
            id: 'recruiterEmail',
            selector: ({ recruiterEmail }) => recruiterEmail || '-',
            name: 'Recruiter',
            style: style.tableText,
          },
        ]}
        initialPage={filters.page}
        data={data}
        forceLoading={isLoading}
        noDataComponent="There are no Permanent Jobs"
        isLoading={isLoading}
        totalPages={totalPages}
        paginationPerPage={filters.limit}
        paginationTotalRows={total}
        onPageChange={handlePageChanged}
        onRowClicked={(row) => history.push(`/permanent-job/office/${row.officeId}/job/${row.id}`)}
        showColumnsToHide={false}
        showTotal={false}
        conditionalRowStyles={[
          {
            when: (row) => row.status === 'active',
            style: {
              backgroundColor: '#99DAE3',
            },
          },
          {
            when: (row) => row.status === 'closed',
            style: {
              backgroundColor: '#F8B5B5',
            },
          },
          {
            when: (row) => row.status === 'hired',
            style: {
              backgroundColor: '#C1F5B9',
            },
          },
          {
            when: (row) => row.status === 'paused',
            style: {
              backgroundColor: '#FDFFC9',
            },
          },
        ]}
      />
    </TabViewContainer>
  );
};
